module.exports = __webpack_public_path__ + "static/media/cp16.e71a7876.pdf";